import {TextSearchFilterComponent} from './text-search-filter/text-search-filter.component';
import {JobDepartment} from '../../api/models/job-department';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CacheDataService} from '../../api/services/cache-data.service';
import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {JobSeniority} from '../../api/models/job-seniority';
import {Company} from '../../api/models/company';

@Component({
  selector: 'company-search',
  templateUrl: './text-search-filter/text-search-filter.component.html',
  styleUrls: ['./text-search-filter/text-search-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanySearchComponent),
      multi: true
    }
  ]
})
export class CompanySearchComponent extends TextSearchFilterComponent<Company> implements ControlValueAccessor, OnInit, AfterViewInit
{
  @ViewChild('scrollDiv') scrollDiv : ElementRef;
  @Input() fixedHeight?: number;
  @Input() showSelected: boolean = false;

  constructor(cacheDataService: CacheDataService, ngZone: NgZone) {
    super(cacheDataService, ngZone);
  }

  dataUpdated(): void {}

  protected getShowSelected(): boolean {
    return this.showSelected;
  }

  protected getHeightValue() : number | undefined {
    if (this.fixedHeight) {
      return this.fixedHeight;
    }
    return undefined;
  }

  ngOnInit() {
    this.callNgOnInit();
  }

  ngAfterViewInit() {
    this.callNgAfterViewInit();
  }

  protected getDivScroller(): ElementRef {
    return this.scrollDiv;
  }

  protected isSelected(target: Company) : boolean {
    const exists = this._value && this._value.selectedValues && this._value.selectedValues.find(x => x.key === target.key);
    return !!exists;

  }

  protected getDisplay(target: Company): string {
    if (!target.name || target.name.length === 0) {
      return '<NONAME>';
    } else {
      return target.name;
    }
  }

  protected newSearch() {
    this.reloading = true;
    this.cacheDataService.cacheDataSearchCompanies({
      pageNumber: 1,
      pageSize: 100,
      names: this._value?.searchTerms ?? [],
    }).subscribe(result => {
      this.currentPage = 1;
      this.totalPages = result.totalPages;
      this.sourceValues = result.page;
      this.reloading = false;
    });
  }
  protected getNextBatch() {
    if (this.currentPage < this.totalPages) {
      this.loading = true;
      this.currentPage++;
      this.cacheDataService.cacheDataSearchCompanies({
        pageNumber: this.currentPage,
        pageSize: 100,
        names: this._value?.searchTerms ?? [],
      }).subscribe(result => {
        this.totalPages = result.totalPages;
        this.loading = false;
        this.sourceValues = [...this.sourceValues, ...result.page];
      });
    }
  }

  protected getSearchPlaceholder(): string {
    return 'Company Keyword...';
  }
}
